module.exports = __webpack_public_path__ + "img/hic-cervical-cancer-female.bee1a10c.png";